import { Component } from '@angular/core';
import { GlobalService } from '../_services/global.service';
import {  Input, OnInit } from '@angular/core';
import { MenuService } from './app.menu.service';
import {
    ColorScheme,
    LayoutService,
    MenuColorScheme,
    MenuMode,
} from './../_services/app.layout.service';
import { FormlyFormOptions } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../_services/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { LanguageService } from '../_services/language.service';

@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html',
    providers: [MessageService]
})
export class AppProfileSidebarComponent implements OnInit {
    componentThemes: any[] = [];

    scales: number[] = [12, 13, 14, 15, 16];
    showProfilo:boolean=false;
    form = new FormGroup({});
    model: any = {
        name:'',
        surname:'',
        email:''
    };
    passwordAttuale:string='';
    passwordRipeti:string='';
    password:string='';
    options: FormlyFormOptions = {};
    tabsFields:any[]=[];
    
    constructor(
        private authService: AuthService, 
        private apiService: ApiService,
        private messageService: MessageService,
        public router: Router,
        public lang:LanguageService,
        public layoutService: LayoutService,
        public menuService: MenuService,
        public globalservice: GlobalService
    ) { }

    get visible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }

    set visible(_val: boolean) {
        this.layoutService.state.profileSidebarVisible = _val;
    }
    get scale(): number {
        return this.layoutService.config().scale;
    }

    set scale(_val: number) {
        this.layoutService.config.update((config) => ({
            ...config,
            scale: _val,
        }));
        localStorage.setItem('appThemeConfig', JSON.stringify(this.layoutService.config()));
    }
    get colorScheme(): ColorScheme {
        return this.layoutService.config().colorScheme;
    }
    set colorScheme(_val: ColorScheme) {
        this.layoutService.config.update((config) => ({
            ...config,
            colorScheme: _val,
        }));
        localStorage.setItem('appThemeConfig', JSON.stringify(this.layoutService.config()));
        document.location.reload();
    }
    get theme(): string {
        return this.layoutService.config().theme;
    }
    set theme(_val: string) {
        this.layoutService.config.update((config) => ({
            ...config,
            theme: _val,
        }));
        localStorage.setItem('appThemeConfig', JSON.stringify(this.layoutService.config()));
        document.location.reload();
    }

    changeColorScheme(colorScheme: ColorScheme) {
        this.colorScheme = colorScheme;
    }

    changeTheme(theme: string) {
        this.theme = theme;
    }


    decrementScale() {
        this.scale--;
    }

    incrementScale() {
        this.scale++;
    }

    ngOnInit() {
        this.tabsFields= [
            {
              fieldGroupClassName: 'grid',
              fieldGroup:[
                {
                  className:'col-12',
                  type: 'input',
                  key: 'username',
                  props:{
                    label:this.lang.el('Nome utente'),
                    disabled:true
                  }
                },
                {
                    className:'col-6',
                    type: 'input',
                    key: 'name',
                    props:{
                      label:this.lang.el('Nome'),
                      maxLength:255,
                      required:true
                    }
                  },
                {
                    className:'col-6',
                    type: 'input',
                    key: 'surname',
                    props:{
                      label:this.lang.el('Cognome'),
                      maxLength:255,
                      required:true
                    }
                  },
                  ,
                {
                    className:'col-12',
                    type: 'input',
                    key: 'email',
                    props:{
                      label:this.lang.el('Email'),
                      maxLength:255,
                      required:true
                    }
                  },
                  
            ]}
        ];
        this.componentThemes = [
            { name: 'indigo', color: '#6366F1' },
            { name: 'blue', color: '#3B82F6' },
            { name: 'purple', color: '#8B5CF6' },
            { name: 'teal', color: '#14B8A6' },
            { name: 'cyan', color: '#06b6d4' },
            { name: 'green', color: '#10b981' },
            { name: 'orange', color: '#f59e0b' },
            { name: 'pink', color: '#d946ef' },
        ];
        const user=this.globalservice.getUser();
  
        this.model= {
            username:user.username,
            name:user.name,
            surname:user.surname,
            email:user.email,
        };
    }

    signout(){
        this.authService.logout();
    }

    addSingle(sev: string, sum: string, det: string) {
        this.messageService.add({severity: sev, summary: sum, detail: det});
    }

    saveProfilo(){
        if(this.password!='' && this.passwordAttuale!='' && this.password==this.passwordRipeti){
        
            let par={
                id:this.globalservice.getUser().id,
                password:this.passwordAttuale
            }
            this.apiService.post('app/checkpwd',par).subscribe(data => {
                if(data.Result=='ko'){
                    this.addSingle('warnings',this.lang.el('Attenzione'), this.lang.el('Password attuale non corrispondente'));
                } else {
                    this.model['loggedUser']=this.globalservice.getUser().id;
                    this.model['id']=this.globalservice.getUser().id;
                    this.model['password']=this.password;
                    this.apiService.post('app/user_update',this.model).subscribe(data => {
                        this.addSingle('success',this.lang.el( 'Successo'), this.lang.el('Profilo aggiornato'));
                        setTimeout(()=>{
                        this.showProfilo=false;
                        this.authService.updateUser(data);
                        },2000);
                    });
                }
            });
        } else {
            this.model['loggedUser']=this.globalservice.getUser().id;
            this.model['id']=this.globalservice.getUser().id;
            this.apiService.post('app/user_update',this.model).subscribe(data => {
            this.addSingle('success',this.lang.el( 'Successo'), this.lang.el('Profilo aggiornato'));
            setTimeout(()=>{
              this.showProfilo=false;
              this.authService.updateUser(data);
            },2000);
        });
        }

       
    }
    
    
  
}


